<div class="p-2 p-lg-3 note-shell">
  <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
    <div class="d-flex align-items-center gap-2">
      <span class="icon-pill" style="width:32px;height:32px;background:#d8e9ff;color:#2267c7">
        <lucide-icon [img]="FileTextIcon" [size]="16"></lucide-icon>
      </span>
      <h1 class="title m-0">{{ isEditMode() ? 'Edit Credit / Debit Note' : 'Credit / Debit Note' }}</h1>
    </div>
    <button class="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-2" type="button" (click)="router.navigateByUrl('/credit-debit-notes')">
      <lucide-icon [img]="ArrowLeftIcon" [size]="14"></lucide-icon>
      BACK TO LIST
    </button>
  </div>

  <div class="panel mb-3">
    <div class="panel-head">Note Header</div>
    <div class="panel-body">
      <div class="row g-2">
        <div class="col-md-3">
          <label class="input-label">Note Type <span class="req">*</span></label>
          <select class="form-select form-select-sm" [ngModel]="form().noteType" (ngModelChange)="patchForm({ noteType: $event })" name="noteType">
            @for (item of noteTypeOptions; track item) {
              <option [value]="item">{{ item }}</option>
            }
          </select>
        </div>

        <div class="col-md-3">
          <label class="input-label">Note Date <span class="req">*</span></label>
          <input class="form-control form-control-sm" type="date" [ngModel]="form().noteDate" (ngModelChange)="patchForm({ noteDate: $event })" name="noteDate" />
        </div>

        <div class="col-md-3">
          <label class="input-label">Client <span class="req">*</span></label>
          <div class="client-select" (click)="toggleClientDropdown($event)">
            <button type="button" class="form-select form-select-sm d-flex align-items-center justify-content-between text-start">
              <span class="client-label">{{ selectedClientLabel() }}</span>
              <lucide-icon [img]="ChevronDownIcon" [size]="14"></lucide-icon>
            </button>
            @if (clientDropdownOpen()) {
              <div class="client-dropdown" (click)="onClientPanelClick($event)">
                <div class="client-search-wrap">
                  <lucide-icon class="client-search-icon" [img]="SearchIcon" [size]="14"></lucide-icon>
                  <input
                    type="text"
                    class="form-control form-control-sm client-search"
                    placeholder="Search client"
                    [ngModel]="clientSearch()"
                    (ngModelChange)="onClientSearchChange($event)"
                    name="clientSearch"
                  />
                </div>
                <div class="client-list">
                  @for (item of filteredClientOptions(); track item) {
                    <label class="client-item" (click)="selectClient(item)">
                      <span>{{ item }}</span>
                      @if (isClientSelected(item)) {
                        <lucide-icon [img]="CheckIcon" [size]="13"></lucide-icon>
                      }
                    </label>
                  }
                  @if (filteredClientOptions().length === 0) {
                    <div class="client-empty">No client found</div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        
        <div class="col-md-3">
          <label class="input-label">Invoice</label>
          <select class="form-select form-select-sm" [ngModel]="form().invoiceId" (ngModelChange)="onInvoiceChange($event)" name="invoiceId" [disabled]="!form().clientName">
            <option value="">{{ form().clientName ? 'Select Invoice' : 'Select Client First' }}</option>
            @for (item of filteredInvoices(); track item.id) {
              <option [value]="item.id">{{ item.label }}</option>
            }
          </select>
        </div>

        <div class="col-12">
          <label class="input-label">Remarks</label>
          <input class="form-control form-control-sm" [ngModel]="form().remarks" (ngModelChange)="patchForm({ remarks: $event })" name="remarks" placeholder="Optional remarks" />
        </div>
      </div>
    </div>
  </div>

  <div class="panel">
    <div class="panel-head d-flex align-items-center justify-content-between">
      <span>Note Rows</span>
      <button class="btn btn-dark btn-sm d-inline-flex align-items-center gap-1" type="button" (click)="addRow()">
        <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
        ADD ROW
      </button>
    </div>
    <div class="panel-body p-0">
      <div class="table-responsive">
        <table class="table table-sm mb-0 note-table">
          <thead>
            <tr>
              <th style="width:70px">S.No.</th>
              <th style="min-width:260px">Particulars</th>
              <th style="width:120px">Qty</th>
              <th style="width:140px">Rate</th>
              <th style="width:160px">Amount</th>
              <th style="width:80px">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (row of lineRows(); track row.id; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>
                  <input class="form-control form-control-sm" [ngModel]="row.particulars" (ngModelChange)="updateRow(row.id, { particulars: $event })" [name]="'particulars' + row.id" placeholder="Enter row details" />
                </td>
                <td>
                  <input class="form-control form-control-sm text-end" type="number" min="0" step="0.01" [ngModel]="row.quantity" (ngModelChange)="updateRow(row.id, { quantity: +$event })" [name]="'quantity' + row.id" />
                </td>
                <td>
                  <input class="form-control form-control-sm text-end" type="number" min="0" step="0.01" [ngModel]="row.rate" (ngModelChange)="updateRow(row.id, { rate: +$event })" [name]="'rate' + row.id" />
                </td>
                <td>
                  <input class="form-control form-control-sm text-end" [ngModel]="row.amount" [name]="'amount' + row.id" readonly />
                </td>
                <td>
                  <button class="btn btn-sm btn-light" type="button" (click)="removeRow(row.id)">
                    <lucide-icon [img]="Trash2Icon" [size]="14"></lucide-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th colspan="4" class="text-end">Total</th>
              <th class="text-end">{{ totalAmount() | number:'1.2-2' }}</th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button class="btn btn-primary d-inline-flex align-items-center gap-2" type="button" (click)="submit()" [disabled]="isSaving()">
      <lucide-icon [img]="SaveIcon" [size]="14"></lucide-icon>
      {{ isSaving() ? 'Saving...' : (isEditMode() ? 'Update Note' : 'Save Note') }}
    </button>
  </div>
</div>
